/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.userBusinessFrequentBuyerPrograms

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.userBusinessFrequentBuyerPrograms.UserBusinessFrequentBuyerProgramsApi
import features.userBusinessFrequentBuyerPrograms.models.FrequentBuyerProgramsModel
import features.userBusinessFrequentBuyerPrograms.serializeUserBusinessFrequentBuyerProgramsState



/**
 * Get a list of frequent buyer programs for this business [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("UserBusinessFrequentBuyerProgramsApi")
class UserBusinessFrequentBuyerProgramsApiJs {

    /**
     * Get a list of frequent buyer programs for this business
     */
    fun getUserBusinessFrequentBuyerPrograms(
        overrideHeaders: String?, 
        businessId: String
    ): Promise<String?>  {
        return GlobalScope.promise {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

            val result = UserBusinessFrequentBuyerProgramsApi().getUserBusinessFrequentBuyerPrograms(
            overrideHeaders = decodedOverrideHeaders,
                        businessId = businessId
        ).toJsonResult<FrequentBuyerProgramsModel>()
        
            return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    

    fun observeUserBusinessFrequentBuyerProgramsState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        UserBusinessFrequentBuyerProgramsApi().userBusinessFrequentBuyerProgramsState.serializeUserBusinessFrequentBuyerProgramsState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
